// Rang-basiertes Rechtesystem – jeder Bereich/jede Aktion pro Rang vergebbar.

export const RAENGE_ORDER = [
  "Director", "Captain", "Lieutenant", "Sergeant II", "Sergeant I",
  "Officer II", "Officer I", "Guard II", "Guard I", "Cadet",
];

export const CAPABILITIES = [
  { key: "area.informationen", label: "Bereich: Allg. Informationen" },
  { key: "area.officer", label: "Bereich: Officer" },
  { key: "area.appellthemen", label: "Bereich: Appellthemen" },
  { key: "area.fehlerliste", label: "Bereich: Fehlerliste" },
  { key: "area.inhaftierung", label: "Bereich: Inhaftierung" },
  { key: "area.haftrechner", label: "Bereich: Haftrechner" },
  { key: "area.langzeit", label: "Bereich: Langzeithäftlinge" },
  { key: "area.einsaetze", label: "Bereich: Einsätze" },
  { key: "area.chaingangs", label: "Bereich: Chain-Gangs" },
  { key: "area.parole", label: "Bereich: Parole" },
  { key: "area.parolelog", label: "Bereich: Parole-Log" },
  { key: "area.register", label: "Bereich: Verbrecherregister" },
  { key: "area.externe", label: "Bereich: Externe Dokumente" },
  { key: "area.lager", label: "Bereich: Lagerbestand" },
  { key: "area.gangkarte", label: "Bereich: Gang-Karte" },
  { key: "area.statistik", label: "Bereich: Statistik" },
  { key: "area.archiv", label: "Bereich: Archiv" },
  { key: "area.gefaengnisordnung", label: "Bereich: Gefängnisordnung" },
  { key: "area.administration", label: "Bereich: Administration" },
  { key: "entry.create", label: "Einträge erstellen" },
  { key: "entry.edit", label: "Einträge bearbeiten" },
  { key: "entry.archive", label: "Einträge archivieren" },
  { key: "entry.delete", label: "Einträge löschen" },
  { key: "officer.manage", label: "Officer verwalten" },
  { key: "officer.vehicles.edit", label: "Fahrzeuge bearbeiten" },
  { key: "officer.suspend", label: "Officer suspendieren / kündigen" },
  { key: "accounts.manage", label: "Accounts verwalten" },
  { key: "roles.manage", label: "Rechte / Verlauf verwalten" },
  { key: "azk.set", label: "Außenzaunkontrolle setzen" },
];
